module.exports = __webpack_public_path__ + "static/media/girl3.4c641168.svg";